import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { getTheme } from '../../global/utils';
import Heading from '../../components/text/Heading';
import CustomSelect from '../../components/forms/Select';
import SelectDate from '../../components/forms/SelectDate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';
import Button from '../../components/buttons/Button';
import alarmsFiltersData from '../../data/alarmsFiltersData';

const FiltersWrapper = styled.div`
  position: fixed;
  top: ${getTheme('height', 'header')};
  right: 0;
  bottom: 0;
  width: 308px;
  margin-right: -308px;
  transition: margin-right 0.3s;
  display: flex;
  flex-direction: column;

  ${props =>
    props.filtersVisibility === true &&
    css`
      margin-right: 0;
    `};
  .filters-heading {
    padding-left: ${getTheme('padding', 'horizontalL')};
    padding-right: ${getTheme('padding', 'horizontalL')};
    padding-top: ${getTheme('padding', 'verticalXL')};
    padding-bottom: ${getTheme('padding', 'verticalXL')};
    display: flex;
    align-items: baseline;
    > :first-child {
      margin-bottom: 0;
    }
    &__close {
      cursor: pointer;
      border: 0;
      margin-left: auto;
      padding: 0;
      font-size: inherit;
      background: transparent;
      color: ${getTheme('textColor', 'alt')};
      svg {
        width: 1rem;
        height: 1rem;
      }
    }
  }
  .filters-inner {
    flex-grow: 1;
    overflow: auto;
    padding-left: ${getTheme('padding', 'horizontalL')};
    padding-right: ${getTheme('padding', 'horizontalL')};
    padding-top: ${getTheme('padding', 'verticalL')};
    padding-bottom: ${getTheme('padding', 'verticalXL')};
  }
`;

class AlarmFilters extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedFilters: props.activeFilters,
      dateFrom: new Date(), //this needs to be dynamic
      dateTo: new Date(),
    };
    this.newFilter = this.newFilter.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
    this.changeDateFrom = this.changeDateFrom.bind(this);
    this.changeDateTo = this.changeDateTo.bind(this);
  }

  changeDateFrom(date) {
    this.setState({ dateFrom: date });
    this.newFilter({ dateFrom: date });
  }

  changeDateTo(date) {
    this.setState({ dateTo: date });
    this.newFilter({ dateTo: date });
  }

  newFilter(filter) {
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        ...filter,
      },
    });
  }

  changeFilters() {
    this.props.filtersCloseAction();
    this.props.updateFilters(this.state.selectedFilters);
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeFilters !== prevProps.activeFilters) {
      this.setState({
        selectedFilters: this.props.activeFilters,
      });
    }
  }
  render() {
    return (
      <FiltersWrapper className="themeDark" filtersVisibility={this.props.filtersVisibility}>
        <div className="filters-heading">
          <Heading level="heading2">
            <h3>Filters</h3>
          </Heading>
          <button
            type="button"
            onClick={this.props.filtersCloseAction}
            className="filters-heading__close"
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>
        <div className="filters-inner">
          <SelectDate
            size="medium"
            label="From"
            date={this.state.dateFrom}
            key={`select_dateFrom_${this.props.activeFilters.dateFrom}`}
            handleChange={element => {
              this.changeDateFrom(element);
            }}
          />
          <SelectDate
            size="medium"
            label="To"
            date={this.state.dateTo}
            key={`select_dateTo_${this.props.activeFilters.dateTo}`}
            minDate={this.state.dateFrom}
            handleChange={element => {
              this.changeDateTo(element);
            }}
          />
          <CustomSelect
            size="medium"
            label="UT"
            defaultValue={alarmsFiltersData.ut[this.props.activeFilters.ut]}
            key={`select_ut_${this.props.activeFilters.ut}`}
            options={alarmsFiltersData.ut}
            handleChange={element => {
              this.newFilter({ ut: element.value });
            }}
          />
          <CustomSelect
            size="medium"
            label="Group"
            defaultValue={alarmsFiltersData.groupid[this.props.activeFilters.groupid]}
            key={`select_group_${this.props.activeFilters.groupid}`}
            options={alarmsFiltersData.groupid}
            handleChange={element => {
              this.newFilter({ groupid: element.value });
            }}
          />
          <CustomSelect
            size="medium"
            label="Trigger"
            defaultValue={alarmsFiltersData.triggerid[this.props.activeFilters.triggerid]}
            key={`select_trigger_${this.props.activeFilters.triggerid}`}
            options={alarmsFiltersData.triggerid}
            handleChange={element => {
              this.newFilter({ triggerid: element.value });
            }}
          />

          <Button onClick={this.changeFilters} iconBefore={<FontAwesomeIcon icon={faCheck} />}>
            Apply
          </Button>
        </div>
      </FiltersWrapper>
    );
  }
}

export default AlarmFilters;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsFilters.js